import React, { useState } from "react";
import Sidebar from "@components/sidebar";
import { Divider } from "@mui/material";
import { getOrders } from "../../redux/slice/orders";
import { useSelector, useDispatch } from "react-redux";
import { getTickets } from "../../redux/slice/tickets";
import { getReservations } from "../../redux/slice/reservations";
import { setFilterModalParams } from "./../../redux/slice/const";
import { Form, FormGroup, Input, Label, Button } from "reactstrap";

export default function FiltersSideBar() {
  const { filterModalParams } = useSelector((store) => store.globalConst);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [auxSelectedOptions, setAuxSelectedOptions] = useState([]);
  const dispatch = useDispatch();

  const headers =
    filterModalParams.view === "orders"
      ? ["status", "paymentMethod"]
      : filterModalParams.view === "tickets"
      ? ["status", "type"]
      : filterModalParams.view === "reservations"
      ? ["status"]
      : "";

  const call =
    filterModalParams.view === "orders"
      ? getOrders
      : filterModalParams.view === "tickets"
      ? getTickets
      : filterModalParams.view === "reservations"
      ? getReservations
      : "";

  const title =
    filterModalParams.view === "orders"
      ? ["Estatus:", "Método de pago:"]
      : filterModalParams.view === "tickets"
      ? ["Estatus:", "Tipo:"]
      : filterModalParams.view === "reservations"
      ? ["Estatus:"]
      : "";

  const closeModal = () => {
    dispatch(
      setFilterModalParams({
        show: false,
        view: filterModalParams.view,
        data: filterModalParams.data,
        args: filterModalParams.args,
        values: filterModalParams.value,
        filters: filterModalParams.filters,
        disable: filterModalParams.disable,
        filtersToShow: filterModalParams.filtersToShow,
      })
    );
  };

  const handleRadioChange = (groupName, value, index) => {
    const auxData = [...filterModalParams.data];
    const auxDataId = [...filterModalParams.data[index]];
    const updatedOptions =
      filterModalParams.filtersToShow.length > 0
        ? filterModalParams.filtersToShow?.map((obj) => ({
            ...obj,
          }))
        : auxSelectedOptions?.map((obj) => ({
            ...obj,
          }));
    filterModalParams.data[index].forEach((e, i) => {
      if (e.value === value) {
        auxDataId.splice(i, 1, {
          value: e.value,
          label: e.label,
          checked: true,
        });
      } else {
        auxDataId.splice(i, 1, {
          value: e.value,
          label: e.label,
          checked: false,
        });
      }
    });

    auxData[index] = auxDataId;

    for (let i = 0; i < filterModalParams.data[index].length; i++) {
      const e = filterModalParams.data[index][i];

      if (e.value === value) {
        const existingIndex = updatedOptions.findIndex(
          (obj) => obj[groupName] !== undefined
        );

        if (existingIndex !== -1) {
          updatedOptions[existingIndex][groupName] = value;
          updatedOptions[existingIndex].label = e.label;
        } else {
          updatedOptions.push({ [groupName]: value, label: e.label });
        }
      }
    }

    setAuxSelectedOptions(updatedOptions);

    setSelectedOptions({
      ...selectedOptions,
      ...filterModalParams.filters,
      [groupName]: value,
    });

    dispatch(
      setFilterModalParams({
        data: auxData,
        show: filterModalParams.show,
        view: filterModalParams.view,
        args: filterModalParams.args,
        filters: filterModalParams.filters,
        filtersToShow: filterModalParams.filtersToShow,
        disable: false,
      })
    );
  };

  const onSubmit = (e, d) => {
    e.preventDefault();
    const auxFilters = {
      ...selectedOptions,
    };
    const auxFiltersToShow = [...auxSelectedOptions];

    const args = {
      eventId: filterModalParams.args.eventId,
      pageSize: filterModalParams.args.pageSize,
      pageNumber: filterModalParams.args.pageNumber,
      searchQuery: filterModalParams.args.searchQuery,
      ...filterModalParams.filters,
      ...selectedOptions,
    };

    dispatch(call(args))
      .unwrap()
      .then(() => {
        setSelectedOptions({});
        setAuxSelectedOptions([]);
      });
    dispatch(
      setFilterModalParams({
        ...filterModalParams,
        args,
        show: false,
        disable: false,
        filters: auxFilters,
        filtersToShow: auxFiltersToShow,
      })
    );
  };

  const clearFilter = () => {
    const args = {
      eventId: filterModalParams.args.eventId,
      pageSize: filterModalParams.args.pageSize,
      pageNumber: filterModalParams.args.pageNumber,
      searchQuery: "",
    };
    dispatch(call(args))
      .unwrap()
      .then(() => {
        setSelectedOptions({});
      });
    dispatch(
      setFilterModalParams({
        view: "",
        data: [],
        args: {},
        values: "",
        filters: {},
        show: false,
        disable: true,
        filtersToShow: [],
      })
    );
  };

  const customStyles = {
    content: {
      top: "19%",
      left: "70%",
      right: "auto",
      bottom: "auto",
      borderBottom: "5px solid #ff8800",
      backgroundColor: "#fff",
      borderLeftColor: "transparent",
      borderRigthColor: "transparent",
      borderTopColor: "transparent",
      borderTopWidth: "0.5em",
      borderTopStyle: "solid",
      borderBottomColor: "#ff000",

      height: "60%",
      width: "17%",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
    },
    form: {
      position: "relative",
      paddingTop: "2rem",
    },
    overlay: {
      backgroundColor: "none",
    },
    form: {
      height: "90%",
    },
    button: {
      bottom: "80%",
      marginTop: "18rem",
      backgroundColor: "#FE4500",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      bottom: "0px",
    },
  };

  return (
    <Sidebar
      size="sm"
      title="Filtrar por"
      headerClassName="mb-1"
      open={filterModalParams.show}
      contentClassName="pt-0 mb-0 bg-white"
      toggleSidebar={() => {
        closeModal();
      }}
    >
      <Form onSubmit={onSubmit} style={customStyles.form}>
        {filterModalParams?.data.map((group, index) => (
          <React.Fragment key={index}>
            {title && <Label className="fs-5 fw-bold">{title[index]}</Label>}
            {group?.map((option, i) => (
              <FormGroup key={i} check className="mb-1 w-100">
                <Input
                  type="radio"
                  name={`radio${index}`}
                  id={option.label}
                  defaultChecked={option.checked}
                  onChange={() =>
                    handleRadioChange(headers[index], option.value, index)
                  }
                />
                <Label htmlFor={option.label} check>
                  {option.label}
                </Label>
              </FormGroup>
            ))}
            {index !== filterModalParams.data.length - 1 && <Divider />}
          </React.Fragment>
        ))}
        <div style={customStyles.buttonContainer}>
          {filterModalParams.filters && (
            <Button
              size="sm"
              color="danger"
              onClick={clearFilter}
              style={customStyles.button}
              disabled={filterModalParams.disable}
            >
              Limpiar
            </Button>
          )}
          <div></div>
          <Button
            size="sm"
            type="submit"
            color="success"
            style={customStyles.button}
            disabled={filterModalParams.disable}
          >
            Aplicar
          </Button>
        </div>
      </Form>
    </Sidebar>
  );
}
